import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { GigyaService } from '../../services/gigya.service';
import { ButtonComponent } from '../../shared/button/button.component';
import { SpinnerComponent } from '../../shared/icons/spinner/spinner.component';
import { WarningIconComponent } from '../../shared/icons/warning/warning.component';
import { LayoutComponent } from '../../shared/layout/layout.component';
import { TitleUnderlineIconComponent } from '../../shared/icons/title-underline/title-underline.component';

@Component({
  selector: 'app-magic-link',
  standalone: true,
  imports: [
    RouterLink,
    TranslatePipe,
    ButtonComponent,
    SpinnerComponent,
    WarningIconComponent,
    LayoutComponent,
    TitleUnderlineIconComponent,
  ],
  templateUrl: './magic-link.component.html',
  styleUrl: './magic-link.component.css',
})
export class MagicLinkComponent implements OnInit {
  error: string | null = null;
  loading = false;
  sent = false;
  email = '';

  constructor(
    private route: ActivatedRoute,
    private gigyaService: GigyaService,
    private translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.email = this.route.snapshot.queryParams['email'] ?? '';
    this.sendLink();
  }

  public async sendLink(): Promise<void> {
    this.loading = true;
    this.sent = false;
    this.error = null;

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.auth.magiclink.email.send, {
      loginID: this.email,
    });

    this.loading = false;
    if (res.errorCode !== 0) {
      this.error = this.translateService.instant('magicLink.sendError');
      return;
    }
    this.sent = true;
  }
}
